import { AppState } from './types'

const initialState = {
  error: null,
  loading: false,
  token: '',
} as AppState

export default initialState